import { v4 as uuidv4 } from 'uuid';
import { useCallback, useState } from 'react';
import { generateQueve } from '../../../../utility/utility';

export const useModalEditImagesList = ({ field, value, parents }) => {
  const [imagesList, setimagesList] = useState(
    value?.map((item) => {
      return {
        uid: uuidv4(),
        img: typeof item === 'string' ? item : null,
        file: item.file ? item.file : null,
        fileUrl: item.fileUrl ? item.fileUrl : null,
        parents,
      };
    }) ?? [],
  );

  const removeImage = (itemId) => {
    setimagesList((prev) => prev.filter((item) => item.uid !== itemId));
  };

  const addImageItem = useCallback(
    generateQueve((file) => {
      setimagesList((fileList) => {
        if (field.limit && fileList.length >= field.limit) {
          return fileList;
        }
        const newItem = {
          uid: uuidv4(),
          fileUrl: URL.createObjectURL(file),
          file,
          parents,
        };
        const newItems = [...fileList, newItem];
        return newItems;
      });
    }),
    [field],
  );

  return { addImageItem, removeImage, imagesList };
};
